// extracted by mini-css-extract-plugin
export default {"claimPremadeButton":"styles_claimPremadeButton__N29-c","bgImage":"styles_bgImage__+WGFY","content":"styles_content__fBDql"};